import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			stockInfoShareholdersSubheaderInfoCls: string;
			stockInfoShareholdersHeaderCls: string;
			stockInfoShareholdersTableDataRowCls: string;
			stockInfoShareholdersTabDataDisclaimerCls: string;
		}
	},

	slug: string
}

class Shareholders extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Stock Info Shareholders Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.stockInfoShareholdersSubheaderInfoCls || '', 'investors_stock_info_shareholders', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.stockInfoShareholdersHeaderCls || '', 'investors_stock_info_shareholders', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.stockInfoShareholdersTableDataRowCls + '1', 'investors_stock_info_shareholders', { animCls: 'animate__fadeIn', once: true});

		if(this.publicVars.cssId.anim?.stockInfoShareholdersTableDataRowCls) {
			const rowsCount = document.querySelectorAll(this.publicVars.cssId.anim?.stockInfoShareholdersTableDataRowCls).length;

			for(let i = 2; i<= rowsCount; i++) {
				scroll.registerAnimatedElement(this.publicVars.cssId.anim?.stockInfoShareholdersTableDataRowCls + i, 'investors_stock_info_shareholders', { animCls: 'animate__fadeIn', once: true});
			}
		}

	}

	bind() {
		this.msg('bind');
	}
}

export default Shareholders;